import { actions } from '@wetransfer/transfer/store/action/consent';

export default function (state = {}, action) {
  const { type } = action;

  switch (type) {
    case actions.SET_TRANSPARENCY_CONSENT_STRING:
      return {
        ...state,
        tcString: action.tcString,
        uiVisible: false,
      };
    case actions.SET_TRANSPARENCY_CONSENT_UI_VISIBLE:
      return {
        ...state,
        uiVisible: action.uiVisible,
      };
  }

  return state;
}
